import apiCaller from '../utils/api-caller';
import { setCookieWithAge } from '../utils/web-helper';

export function postFetch(config){
  const EXT_SERVICE_MODE = 'cors';
  const EXT_SERVICE_CREDENTIALS = 'include';

  const url = config.path;
  const extServiceFlag = config.extServiceFlag;
  const params = config.params || {};

  let requestConfig = {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest",
    },
  }
  if (extServiceFlag) {
    requestConfig['mode'] = EXT_SERVICE_MODE;
    requestConfig['credentials'] = EXT_SERVICE_CREDENTIALS;
  }

  var tokenElement = document.querySelector('[name=csrf-token]');
  if(!!tokenElement){
    requestConfig.headers['X-CSRF-Token'] = tokenElement.getAttribute('content');
  }

  requestConfig.body = JSON.stringify(params);
  
  return fetch(url, requestConfig)
}

export function emailExistsApi(params){
  return apiCaller({method: 'post', path: '/api/v3/email_exists', params:params});
}

export function parentUserCreationApi(params) {
  return postFetch({path:"/users?form_source=Signup Page", params: params, extServiceFlag: true});
}